import { useQuery } from "@tanstack/react-query";

import { useApi } from "@/shared/api/use-api";

type Params = {
  userId?: number;
  jobId?: string;
  xStatId?: string;
  yStatId?: string;
  zStatId?: string;
};

export const useGetChartData = ({ userId, jobId, xStatId, yStatId, zStatId }: Params) => {
  const { statsControllerApi } = useApi();

  return useQuery({
    queryKey: [`getChartData`, userId, jobId, xStatId, yStatId, zStatId],
    queryFn: ({ signal }) => {
      return statsControllerApi.queryStatsTableFull(
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        userId!,
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        jobId!,
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xStatId!,
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        yStatId!,
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        zStatId!,
        {
          signal,
        }
      );
    },
    enabled: !!jobId && !!userId && !!xStatId && !!yStatId && !!zStatId,
    retry: 0,
  });
};
